import { resizeDesignerResponsiveColumn, setDesignerResponsiveColumns } from "../../designer-responsive-actions";
import { getSdInstance, resolveKuikaIdRef } from "../helpers";
import type { ToolHandlerGroup } from "../types";

function safeParse(val: any): any {
  if (val == null) return val;
  if (typeof val === "string") {
    try {
      return JSON.parse(val);
    } catch {
      return val;
    }
  }
  return val;
}

export const responsiveTools: ToolHandlerGroup = {
  sync: {
    ui_structure_set_responsive_columns: (input) => {
      // `@alias` / `$N` kuikaId references come from the server-side
      // ui_render translator. When a Row declares tablet/mobile columns
      // the translator auto-assigns an alias (`@_r0`) because the
      // translator doesn't know the real numeric kuikaId until
      // ui_structure_add_components commits. Resolving the ref here
      // mirrors what the property and configure handlers already do —
      // without it, `parseInt("@_r0", 10)` is NaN, the Row lookup fails
      // with "Component not found", and the tablet/mobile breakpoints
      // silently never land. The default cascade then copies desktop
      // spans to every breakpoint, producing the identical-column-width
      // bug reported against responsive layouts.
      return setDesignerResponsiveColumns(getSdInstance(), {
        kuikaId: resolveKuikaIdRef(input.kuikaId),
        desktop: safeParse(input.desktop),
        tablet: safeParse(input.tablet),
        mobile: safeParse(input.mobile)
      });
    },

    ui_structure_resize_column: (input) => {
      // Same @alias/$N resolution as set_responsive_columns — resize_column
      // is the per-column counterpart and arrives via the same render
      // expansion path.
      return resizeDesignerResponsiveColumn(getSdInstance(), {
        rowKuikaId: resolveKuikaIdRef(input.rowKuikaId),
        columnIndex: input.columnIndex,
        span: input.span,
        device: input.device
      });
    }
  }
};
